// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/astroturf/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n  ._1UqzVcjxvXSzZbvZKvXYKi button {\n    background: black;\n    width: 24px;\n    height: 24px;\n    border: 1px solid white;\n    outline: none;\n    margin: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: white;\n  }\n  ._1UqzVcjxvXSzZbvZKvXYKi svg {\n    color: white;\n    font-size: 12px;\n  }\n  ._1UqzVcjxvXSzZbvZKvXYKi button:hover {\n    background: #505050;\n    box-shadow: -2px -2px 8px rgba(255, 255, 255, 0.9), 2px 2px 8px rgba(255, 255, 255, 0.9);\n  }\n  ._1UqzVcjxvXSzZbvZKvXYKi button:active {\n    outline: none;\n    border: none;\n    scale: 0.9;\n  }\n", ""]);
// Exports
exports.locals = {
	"zoom": "_1UqzVcjxvXSzZbvZKvXYKi"
};
module.exports = exports;
